import { useCallback, useState, lazy, Suspense } from "react";
import styles from "./SnakeGame.module.scss";
import classNamesBind from "classnames/bind";
import { Icon } from "../Icon";
import ClipLoader from "react-spinners/ClipLoader";

const SnakeGameWrapper = lazy(
  () => import(/* webpackChunkName: "SnakeGameWrapper" */ "./SnakeGameWrapper"),
);

const cn = classNamesBind.bind(styles);

export function SnakeGame() {
  const [isPlaying, setIsPlaying] = useState(false);

  const play = useCallback(() => {
    setIsPlaying(true);
  }, []);

  return (
    <div className={cn("game", { "is-playing": isPlaying })}>
      {!isPlaying && (
        <button className={cn("start")} onClick={play}>
          <Icon icon="play" type="solid" />
        </button>
      )}
      <Suspense
        fallback={
          <div className={cn("loader")}>
            <ClipLoader size={50} color="#F9FAFA" />
          </div>
        }
      >
        <SnakeGameWrapper isPlaying={isPlaying} />
      </Suspense>
    </div>
  );
}
